import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import * as yup from "yup";
import { request, handleErrors } from "../../../services/helpers";
import { yupResolver } from "@hookform/resolvers";

const schema = yup.object().shape({
  contents: yup.string().required(),
});

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";

const inputErrorClass = "border border-red-500 b-2 text-red-500";
const labelClass =
  "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

export default function InviteNotificationForm({
  open,
  handleClose,
  eventId,
  eventName,
}) {
  const { register, handleSubmit, reset, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const [error, setError] = useState(null);

  const handleCreateNotification = async (data) => {
    const { contents } = data;
    let formData = {
      contents,
      sendToAll: true,
      eventId: eventId,
      url: "https://www.2gethr.xyz/memberApp/events/" + eventId,
    };
    try {
      const res = await request.post("/event/sendInviteNotification", formData);
      handleClose();
    } catch (e) {
      setError(handleErrors(e));
    }
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <div className="py-8 px-8">
          <button onClick={handleClose} className="font-bold">
            <CloseIcon /> CLOSE
          </button>
        </div>
        <div className="px-8">
          <div className="text-4xl font-rubik font-bold leading-10">
            <h1>Send Invite Notification</h1>
          </div>
        </div>
        {/* <div className="px-8 pt-8 flex justify-between">
          <div className="text-md font-rubik">
            <h4>{eventName}</h4>
          </div>
        </div> */}
        {/* <div className="px-8 pt-2">
          <hr className="w-full border-black bg-black" />
        </div> */}
        <div className="px-8 py-4">
          <form onSubmit={handleSubmit(handleCreateNotification)}>
            <label className={labelClass} htmlFor="contents">
              Notification Content
            </label>
            <input
              name="contents"
              className={classNames({
                [inputClass]: true,
                [inputErrorClass]: errors.contents && errors.contents.message,
              })}
              ref={register}
            />
            {errors.contents && errors.contents.message && (
              <div className="text-xs text-red-500 flex flex-row-reverse">
                <span>{errors.contents.message}</span>
              </div>
            )}
            <button className="bg-yellow-500 py-4 px-16 rounded font-bold text-sm tracking-widest leading-4 uppercase outline-none">
              SUBMIT
            </button>
          </form>
        </div>
      </Dialog>
    </div>
  );
}
